import { ServiceCode, User } from 'types';
import { constant } from 'lodash-es';
import { createNegateVariants } from './createNegateVariants';
import { createPermission } from './createPermission';

const SUPER_ADMINS = [
  'sedx',
  'nvk',
  'v',
  'tony1000',
  'user1',
  'admin2',
  'supertony1000',
  'superadmin'
];

const isStaff = createPermission((user: User) => !!user.RootUserId);

const isSuperAdmin = createPermission((user: User) => {
  if (isStaff(user)) return false;
  return SUPER_ADMINS.includes(user.Username);
});

const isAdmin = createPermission((user: User) => {
  if (isStaff(user)) return false;
  return user.Role === 'admins';
});

const isSpectator = createPermission((user: User) => user.Role === 'observers');

const isGroupAdmin = createPermission(
  (user: User) =>
    isAdmin(user) ||
    isSuperAdmin(user) ||
    user.Groups.some((group) => group.GroupName === 'groupsadmins')
);

const isFirmwareAdmin = createPermission(
  (user: User) => isAdmin(user) && user.Privileges.includes('firmwareAdmin')
);

const isBlockedUser = createPermission(
  (user: User) => !!user.Blocks?.includes(ServiceCode.MONI_PRO)
);

const isBottlerManager = createPermission(
  (user) => isAdmin(user) || user.Privileges.includes('manageBottler')
);

const basePermissions = {
  isSuperAdmin,
  isAdmin,
  isSpectator,
  isGroupAdmin,
  isFirmwareAdmin,
  isBlockedUser,
  isStaff,
  isBottlerManager
};

export const permissions = {
  ...basePermissions,
  not: createNegateVariants(basePermissions),
  allow: createPermission(constant(true)),
  deny: createPermission(constant(false))
};
